import { connect } from 'react-redux';
import { deviationThreadUpdated } from '../../../CommentThread/actionCreators';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
const mapDispatchToProps = {
    onThreadUpdated: deviationThreadUpdated,
    focusEditor
};
export default connect(null, mapDispatchToProps);
